import { Controller } from '@hotwired/stimulus'
import { closeDialog, formDialog } from '../../lib/dialogs.js'

// Opens markup held in a <template> as a bottom-up sheet, so the screen behind stays readable
// while the sheet asks for the one thing it needs. Shipping it inside a <template> keeps the
// form server-built, with its own CSRF token, until the sheet actually opens.
export default class extends Controller {
  static targets = ['template']

  open() {
    formDialog(this.templateTarget.innerHTML, { target: this.sheetContainer })
  }

  // bootstrap pulls focus back into an open modal, so a sheet raised over one has to be
  // built inside it — from the body, its fields take the focus and lose it at once
  get sheetContainer() {
    return this.element.closest('.modal') || 'body'
  }

  // the sheet lives outside this element, so leaving the screen has to take it down
  disconnect() {
    closeDialog()
  }
}
